export default function (error) {
  let errorObj
  if (typeof error === 'string') {
    errorObj = new Error(error)
  } else if (typeof error === 'object' && error.message) {
    errorObj = error
  } else {
    errorObj = new Error('Incorrectly configured log')
  }

  if (window.appDebug) {
    window.console.error(errorObj)
  }
  window.newrelic.noticeError(errorObj)
}

export const triggerNewRelicError = (error, attributes = {}) => {
  if (!window.newrelic || !error) {
    return
  }

  if (Object.getOwnPropertyNames(attributes).length) {
    window.newrelic.noticeError(error, attributes)
  } else {
    window.newrelic.noticeError(error)
  }
}

/**
 * Error handler function to log errors in newrelic primarily to be passed to Microfrontends
 * Keep the old fashion function way so `this` can be bound to the parcel's name
 * @param err
 */
export function globalErrorHandler (err) {
  if (window.newrelic && typeof window.newrelic.noticeError === 'function' && err) {
    window.newrelic.noticeError(err, {
      microfrontend: this,
      errorStackTrace: err.stack,
      patientId: window.AwsAuth?.currentSessionData?.idToken?.decodePayload?.()?.patient_id ?? 'anonymous',
      sessionStorage: sessionStorage.setItem('tssc', 1) || sessionStorage.getItem('tssc') === '1' || sessionStorage.removeItem('tssc')
    })
  } else {
    console.error(err)
  }
}
